import { MAGENTO_URI } from 'global/constants';

export default function useBrandImages(source) {
  let bannerLink, promoImageLink;

  const images = source?.split('\r\n');

  if (images) {
    const getImage = index => images[index]?.split('url=');
    const [, ...banner] = getImage(0);
    const [, ...promo] = getImage(1);

    const getImagePath = text => text[0]?.slice(1)?.split(`"`)[0];
    const bannerImage = getImagePath(banner);
    const promoImage = getImagePath(promo);

    const getImageLink = image => `${MAGENTO_URI}/media/${image}`;
    bannerLink = getImageLink(bannerImage);
    promoImageLink = getImageLink(promoImage);
  }

  return { bannerLink, promoImageLink };
}
